import { MetadataProgressDialog } from "@/components/Dialogs/MetadataProgressDialog"
import { closeSession } from "@/routing/project-session"
import { FilesInfo } from "@/storage/file-system"
import { Sentry } from "@/telemetry/sentry"
import { isMetadataFinishedAtom } from "../app-state"
import { dialogsAtom, pushDialog } from "../dialogs-state"
import { metadataImporter } from "../importing/metadata-importing"
import { store } from "../store"
import { ProjectItem } from "./projects-service"
import { projectAtom } from "./projects-state"

// Called only after setup is confirmed. Fast imports skip the dialog entirely;
// slow imports continue the same prefetch while showing its existing progress.
export async function waitForCullingMetadata(project: ProjectItem, filesInfo?: FilesInfo) {
	const indexing = metadataImporter.start(project, filesInfo)
	let cancelWait: (completed: boolean) => void = () => {}
	const canceled = new Promise<boolean>((resolve) => {
		cancelWait = resolve
	})
	const dialogProps = {
		onCancel: () => {
			void metadataImporter.pauseAndCancel().catch((error) => Sentry.captureException(error))
			// Release setup before closing: closeSession may be queued behind it.
			cancelWait(false)
			void closeSession({ reason: "cancel_metadata_indexing" }).catch((error) =>
				Sentry.captureException(error),
			)
		},
	}
	if (metadataImporter.isInProgress && !store.get(isMetadataFinishedAtom)) {
		pushDialog(MetadataProgressDialog, dialogProps)
	}
	try {
		const completed = await Promise.race([indexing, canceled])
		return completed && store.get(projectAtom)?.id === project.id
	} finally {
		// Never dismiss another dialog opened while indexing or closing the project.
		store.set(dialogsAtom, (dialogs) => dialogs.filter(([, props]) => props !== dialogProps))
	}
}
